export default {
  lang: {
    selectAll: 'Pilih semua sebagai halaman',
    selected: 'Dipilih',
    term: 'Artikel',
    deselect: 'Batalkan pilihan',
  },
};
